var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 172,
    viewBox: "0 0 284 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6440_55856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.125 89.5838L180.327 89.097C180.939 89.004 181.52 89.4873 181.624 90.1763L184.017 105.927L178.599 106.751L176.206 91C176.102 90.311 176.513 89.6768 177.125 89.5838Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.066 57.4129L172.744 57.7659L177.566 89.5181L179.889 89.1651L175.066 57.4129Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.341 55.7971L158.736 59.3857C158.4 59.4368 158.174 59.7852 158.231 60.1638C158.289 60.5425 158.608 60.808 158.944 60.7569L182.549 57.1683C182.886 57.1172 183.111 56.7688 183.054 56.3902C182.996 56.0115 182.677 55.746 182.341 55.7971Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9889 75.6675C72.8897 75.0144 72.3391 74.5564 71.7591 74.6446C71.1791 74.7327 70.7894 75.3337 70.8886 75.9868L77.706 120.875C77.8052 121.528 78.3558 121.986 78.9358 121.898C79.5157 121.809 79.9055 121.208 79.8063 120.555L72.9889 75.6675Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9057 91.7269L72.8648 92.1892C70.9411 92.4816 69.0713 90.6687 68.6871 88.1389L78.6923 86.6179C79.0765 89.1476 77.8294 91.4344 75.9057 91.7269Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.082 59.8828L162.605 59.4992L164.025 68.8504C164.144 69.6353 163.675 70.359 162.978 70.465C162.281 70.5709 161.618 70.0194 161.499 69.2344L160.078 59.8833L160.082 59.8828Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5833 147.208C82.5833 147.208 185.141 131.617 185.586 131.549C186.031 131.481 186.401 131.073 186.615 130.419L192.625 118.749L76.703 136.372L80.7287 145.351C81.1412 146.567 81.8875 147.314 82.5864 147.208L82.5833 147.208Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6524 115.367C93.9954 114.524 92.6356 111.333 91.9148 109.314C91.5613 108.319 90.6438 107.711 89.7123 107.853L67.203 111.275C66.1103 111.441 65.5204 112.765 66.048 113.881L76.9615 137.041L192.22 119.518L202.908 102.175C203.705 100.883 202.696 99.0933 201.289 99.307L95.6524 115.367Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.527 80.0531L118.005 83.173L119.992 96.2538L140.513 93.134L138.527 80.0531Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.703 94.3845L120.182 97.5043L122.168 110.585L142.69 107.465L140.703 94.3845Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.354 95.0457L135.346 95.1988L137.333 108.28L138.341 108.127L136.354 95.0457Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.233 94.608L138.225 94.7612L140.212 107.842L141.22 107.689L139.233 94.608Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.596 95.921L129.589 96.0742L131.575 109.155L132.583 109.002L130.596 95.921Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.475 95.4833L132.468 95.6365L134.454 108.717L135.462 108.564L133.475 95.4833Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.838 96.7963L123.831 96.9495L125.817 110.03L126.825 109.877L124.838 96.7963Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.717 96.3587L126.71 96.5119L128.696 109.593L129.704 109.44L127.717 96.3587Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.959 97.234L120.952 97.3872L122.938 110.468L123.946 110.315L121.959 97.234Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.177 80.714L133.17 80.8672L135.156 93.948L136.164 93.7949L134.177 80.714Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.056 80.2763L136.049 80.4295L138.036 93.5104L139.043 93.3572L137.056 80.2763Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.42 81.5893L127.412 81.7425L129.399 94.8234L130.406 94.6702L128.42 81.5893Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.299 81.1517L130.291 81.3049L132.278 94.3857L133.285 94.2325L131.299 81.1517Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.662 82.4647L121.654 82.6179L123.641 95.6987L124.648 95.5456L122.662 82.4647Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.541 82.027L124.533 82.1802L126.52 95.2611L127.527 95.1079L125.541 82.027Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.783 82.9024L118.775 83.0555L120.762 96.1364L121.769 95.9832L119.783 82.9024Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.495 83.5545L94.9734 86.6743L96.9601 99.7552L117.482 96.6354L115.495 83.5545Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.672 97.8859L97.15 101.006L99.1367 114.087L119.658 110.967L117.672 97.8859Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.323 98.547L112.315 98.7002L114.302 111.781L115.309 111.628L113.323 98.547Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.202 98.1094L115.194 98.2626L117.181 111.343L118.188 111.19L116.202 98.1094Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.565 99.4224L106.557 99.5756L108.544 112.656L109.552 112.503L107.565 99.4224Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.444 98.9847L109.436 99.1379L111.423 112.219L112.43 112.066L110.444 98.9847Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.807 100.298L100.799 100.451L102.786 113.532L103.794 113.379L101.807 100.298Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.686 99.8601L103.678 100.013L105.665 113.094L106.673 112.941L104.686 99.8601Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.928 100.735L97.9204 100.889L99.9071 113.969L100.915 113.816L98.928 100.735Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.146 84.2154L110.138 84.3686L112.125 97.4494L113.133 97.2962L111.146 84.2154Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.025 83.7777L113.017 83.9309L115.004 97.0118L116.012 96.8586L114.025 83.7777Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.388 85.0907L104.38 85.2439L106.367 98.3248L107.375 98.1716L105.388 85.0907Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.267 84.6531L107.259 84.8062L109.246 97.8871L110.254 97.7339L108.267 84.6531Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6302 85.9661L98.6226 86.1193L100.609 99.2001L101.617 99.0469L99.6302 85.9661Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.509 85.5284L101.502 85.6816L103.488 98.7624L104.496 98.6093L102.509 85.5284Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7513 86.4037L95.7437 86.5569L97.7303 99.6378L98.738 99.4846L96.7513 86.4037Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.558 76.5518L141.036 79.6716L143.023 92.7524L163.545 89.6326L161.558 76.5518Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.735 90.8831L143.213 94.0029L145.2 107.084L165.721 103.964L163.735 90.8831Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.386 91.5443L158.378 91.6975L160.365 104.778L161.372 104.625L159.386 91.5443Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.265 91.1066L161.257 91.2598L163.244 104.341L164.251 104.187L162.265 91.1066Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.628 92.4196L152.62 92.5728L154.607 105.654L155.615 105.5L153.628 92.4196Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.507 91.982L155.499 92.1351L157.486 105.216L158.493 105.063L156.507 91.982Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.87 93.295L146.862 93.4482L148.849 106.529L149.857 106.376L147.87 93.295Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.749 92.8573L149.741 93.0105L151.728 106.091L152.736 105.938L150.749 92.8573Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.991 93.7326L143.983 93.8858L145.97 106.967L146.978 106.814L144.991 93.7326Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.209 77.2126L156.201 77.3658L158.188 90.4467L159.196 90.2935L157.209 77.2126Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.088 76.775L159.08 76.9281L161.067 90.009L162.075 89.8558L160.088 76.775Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.451 78.088L150.444 78.2412L152.43 91.322L153.438 91.1688L151.451 78.088Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.33 77.6503L153.323 77.8035L155.309 90.8844L156.317 90.7312L154.33 77.6503Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.693 78.9633L144.686 79.1165L146.672 92.1974L147.68 92.0442L145.693 78.9633Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.572 78.5256L147.565 78.6788L149.551 91.7597L150.559 91.6065L148.572 78.5256Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.814 79.401L141.807 79.5542L143.793 92.635L144.801 92.4819L142.814 79.401Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.36 108.682C193.325 108.536 193.974 107.536 193.809 106.449C193.644 105.363 192.728 104.601 191.763 104.747C190.798 104.894 190.149 105.894 190.314 106.981C190.479 108.067 191.396 108.829 192.36 108.682Z",
    fill: "#808080"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M219.445 102.468C253.128 65.0245 194.071 131.422 215.443 137.501C223.183 139.702 258.971 153.015 246.957 128.993C260.069 132.078 264.395 148.486 255.461 159.021C230.878 188.008 141.992 159.787 111.898 157.019C68.3791 153.015 46.7602 172.683 24.8602 168.029C6.91039 164.215 95.0384 128.993 6.35205 124.489C-20.8012 123.11 54.373 82.9503 71.8806 128.993C77.7034 144.306 183.429 142.505 219.445 102.468Z",
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0213 127.618C52.8199 116.408 40.6812 115.941 35.0121 117.108C36.8462 118.109 39.8142 118.409 45.0165 119.611C51.5193 121.112 60.023 141.631 56.0213 127.618Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172.966 142.941C192.358 143.042 194.208 134.589 192.708 130.35C190.842 131.432 190.073 133.459 187.574 136.872C184.45 141.137 148.724 142.815 172.966 142.941Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M232.598 86.9303C236.767 78.7561 245.204 64.4095 245.604 72.4169C246.004 80.4243 237.1 85.4289 232.598 86.9303Z",
    fill: "#EEEEEE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M219.287 93.0994C220.191 88.6545 222.363 80.6526 223.814 84.2045C225.265 87.7563 221.401 91.6143 219.287 93.0994Z",
    fill: "#EEEEEE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6881 103.095C50.3583 98.566 43.7584 90.6991 43.9965 95.4602C44.2347 100.221 50.5568 102.534 53.6881 103.095Z",
    fill: "#EEEEEE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2533 92.5365C48.1482 85.0123 43.2629 71.277 48.563 76.5296C53.8632 81.7823 52.5649 89.3895 51.2533 92.5365Z",
    fill: "#EEEEEE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M182.577 19.3966L193.433 10.0862L223.29 0L254.697 21.7242L262.064 44.2243L242.289 61.6813L218.249 58.1899L207.392 65.5606V54.6985L186.454 41.1209L182.577 19.3966Z",
    fill: "#EEEEEE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M204.545 29.9193C201.782 28.6441 200.921 25.9541 202.226 23.1232C203.511 20.2931 206.108 19.1866 208.875 20.4533C211.65 21.7239 212.503 24.4101 211.218 27.2402C209.913 30.0711 207.324 31.1815 204.545 29.9193ZM204.757 24.2819C204.024 25.8848 204.146 27.3795 205.45 27.9866C206.727 28.5613 207.946 27.6807 208.671 26.0739C209.416 24.4663 209.293 22.9509 208.02 22.3677C206.712 21.7691 205.494 22.6705 204.757 24.2819ZM214.735 34.5847C211.972 33.3095 211.111 30.6195 212.416 27.7886C213.7 24.9585 216.298 23.852 219.065 25.1187C221.84 26.3893 222.692 29.0755 221.408 31.9056C220.103 34.7365 217.514 35.8469 214.735 34.5847ZM214.947 28.9473C214.213 30.5502 214.336 32.0449 215.639 32.652C216.917 33.2267 218.136 32.3461 218.861 30.7393C219.606 29.1317 219.483 27.6163 218.209 27.0331C216.902 26.4345 215.684 27.3358 214.947 28.9473ZM219.319 40.6219L225.084 28.0175L227.547 29.1453L226.845 30.6807L226.946 30.7271C227.631 30.143 228.774 29.564 230.317 30.2707C232.342 31.1976 233.319 33.5431 231.875 36.6777C230.483 39.7441 228.095 40.6607 226.003 39.7029C224.51 39.0193 224.136 37.8074 224.129 36.8859L224.061 36.855L221.816 41.7651L219.319 40.6219ZM225.439 33.7102C224.674 35.3599 224.885 36.7727 226.121 37.3488C227.398 37.9236 228.603 37.1182 229.336 35.4945C230.074 33.9038 229.904 32.4897 228.614 31.8988C227.365 31.3272 226.183 32.0612 225.439 33.7102ZM239.582 37.9408C239.765 37.2494 239.398 36.5811 238.566 36.1903C237.753 35.828 236.963 35.9257 236.717 36.4864C236.519 36.8959 236.693 37.3633 237.481 37.9382L238.963 39.025C240.573 40.2111 241.071 41.398 240.477 42.718C239.643 44.5196 237.472 44.9845 235.03 43.8768C232.562 42.7368 231.617 40.9673 232.224 39.0822L234.738 40.2331C234.528 41.0043 234.94 41.642 235.856 42.0714C236.771 42.4801 237.544 42.3953 237.814 41.8048C238.03 41.3323 237.777 40.8594 236.998 40.2883L235.619 39.2894C234.031 38.144 233.546 36.8404 234.175 35.4859C234.97 33.7272 236.981 33.3218 239.343 34.4032C241.654 35.4614 242.587 37.2147 241.927 39.0144L239.582 37.9408ZM249.273 35.3988L245.141 43.8532L242.981 42.8645L246.675 34.2093L249.273 35.3988ZM241.565 45.1137C241.903 44.3298 242.833 43.9906 243.622 44.3621C244.377 44.6974 244.737 45.6275 244.382 46.4037C244.023 47.1883 243.084 47.5237 242.334 47.1799C241.541 46.8169 241.189 45.8906 241.565 45.1137Z",
    fill: "#5E696E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M247.522 116.194C248.965 111.211 259.637 110.618 267.166 111.613C277.688 112.338 286.13 120.641 280.623 126.205C275.115 131.769 273.167 122.136 260.089 120.6C247.011 119.064 245.719 122.422 247.522 116.194Z",
    fill: "#EEEEEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6440_55856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 163.073,
    height: 84.0768,
    fill: "white",
    transform: "matrix(0.988641 -0.150299 0.150155 0.988662 42.5488 71.1841)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotFound);
export default __webpack_public_path__ + "static/media/icon-not-found.8cff43dba18969b6a34529d3c73339b2.svg";
export { ForwardRef as ReactComponent };